import React, { useEffect, useState } from "react";

// import "antd/dist/antd.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";
import { FaTrash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { Box } from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import DrawerButton from "components/allForm/component/buttons/drawerButton";

const TdsRecords = ({
  autoCount,
  deleteMultipleTdsItem,
  tdsRecord,
  handleOnChange,
  remainingTdsAmount,
  currency,
  role
}) => {
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
  const [tdsPercent, setTdsPercent] = useState(tdsRecord?.prc || 10);
  const [editPercentNum, setEditPercentNum] = useState(true);
  const handleEditTDSPercentange = () => {
    setEditPercentNum(false);
  };
 
  useEffect(()=>{
    if(remainingTdsAmount){
      handleOnChange('bsAmt',remainingTdsAmount);
    }
  },[])
  return (
    <div
      className={`payment-listing_box ${addTogglePaymentIdx ? "show" : "hide"}`}
    >
      <div className="payment-list_array">
        <div className="d-flex">
          <span className="payment-details">TDS Details {autoCount + 1}</span>
          <span className="amountSpan">
          {currency?.symbol || "₹" } { formatAmountIndianRupees(Number(tdsRecord?.bsAmt || 0))}
          </span>
        </div>
        
        <div className="d-flex toggleImage-content">
        {["Admin", "Manager", "Accountant"].includes(role) && (
          <div className="d-flex mx-3">
            <span>
              <FaTrash
                style={{
                  fontSize: "16px",
                  color: "red",
                  cursor: "pointer",
                }}
                onClick={()=>{
                    deleteMultipleTdsItem()
                  }
                }
              />
            </span>
          </div>
        )}
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
       
      </div>
      <div
        className={`payment-inner_box mb-4 ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>Total Amount</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <span className="rupee-symbol">{currency?.symbol || "₹" }</span>{" "}
                </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  placeholder="Total Amount "
                  name="Total Amount "
                  onValueChange={(e) => {
                    handleOnChange('bsAmt',e.value);
                  }}
                  value={tdsRecord?.bsAmt || ""}

                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </InputGroup>
            </Box>
           
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>TDS Percent</Form.Label>
              <InputGroup className="input-group">
                <Form.Control
                  type="number"
                  placeholder="TDS Percent"
                  value={tdsPercent}
                  disabled={editPercentNum}
                  onChange={(e) => {
                    setTdsPercent(e.target.value);
                  }}
                />

                <InputGroup.Text>
                  {editPercentNum ? (
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                      alt="edit"
                      className="edit-button"
                      onClick={handleEditTDSPercentange}
                    />
                  ) : (
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                      alt="edit"
                      className="edit-button"
                      onClick={() => 
                        {
                          setEditPercentNum(true)
                          handleOnChange('prc',tdsPercent);
                        }
                      }
                    />
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Box>
          </Col>
        </Row>
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>TDS Amount</Form.Label>

              <InputGroup>
                <InputGroup.Text>
                  <span className="rupee-symbol">{currency?.symbol || "₹" }</span>{" "}
                </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  name="TDS Amount"
                  disabled
                  value={tdsRecord?.tdsAmt || ""}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </InputGroup>
            </Box>
          </Col>
          <Col></Col>
        </Row>
      </div>
    </div>
  );
};

export default TdsRecords;
